import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Smartphone, X } from "lucide-react";

export default function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("fg-install-dismissed") === "1");
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;
    const ios = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    setIsIos(ios);
    const handler = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (dismissed || (!evt && !isIos)) return null;

  const dismiss = () => { localStorage.setItem("fg-install-dismissed", "1"); setDismissed(true); };
  const install = async () => {
    if (!evt) return;
    evt.prompt();
    const { outcome } = await evt.userChoice;
    if (outcome === "accepted") dismiss();
  };

  return (
    <div className="flex items-center gap-3 rounded-2xl border border-primary/30 bg-primary/5 px-4 py-3 mb-6" data-testid="install-prompt">
      <Smartphone className="w-5 h-5 text-primary shrink-0" />
      <div className="flex-1 text-sm">
        <p className="font-medium">Add Futuregen to your home screen</p>
        <p className="text-xs text-muted-foreground">
          {evt ? "One tap to install — opens full-screen with your dashboard ready." : "Tap Share, then \"Add to Home Screen\" in Safari."}
        </p>
      </div>
      {evt && <Button size="sm" onClick={install} data-testid="install-app-button">Install</Button>}
      <button onClick={dismiss} className="p-1 rounded-md hover:bg-secondary" aria-label="Dismiss" data-testid="install-dismiss-button"><X className="w-4 h-4" /></button>
    </div>
  );
}
